import { Step } from 'react-joyride';
import React from 'react';

export const TooltipData = (): Step[] => {
  return [
    {
      target:
        '.catalog-screen-v2 .catalog-list .catalog-list-item-container:first-of-type .catalog-list-item .catalog-list-item-info-container .catalog-list-item-button-container .catalog-list-item-add-to-cart',
      spotlightPadding: 5,
      disableBeacon: true,
      offset: 0,
      floaterProps: {
        hideArrow: true,
        styles: {
          floaterOpening: {
            top: '-5px',
          },
        },
      },
      content: (
        <div className="tour-guide-popup-container-content">
          <span className="primary-font-semibold tour-guide-popup-container-content-title">
            Add to cart
          </span>
          <span className="primary-font-regular tour-guide-popup-container-content-description">
            <span className="primary-font-semibold">
              Click on “Add” to add product to the cart.
            </span>
          </span>
        </div>
      ),
      placement: 'bottom-end',
      spotlightClicks: true,
      data: {
        moduleStartTooltip: 2,
        tooltip: true,
        goBack: false,
        arrowDirection: 'top-end',
      },
    },
    {
      target:
        '.catalog-screen-v2 .catalog-screen-v2-footer-container .catalog-screen-v2-footer-popup',
      spotlightPadding: 5,
      disableBeacon: true,
      offset: 0,
      floaterProps: {
        hideArrow: true,
        styles: {
          floaterOpening: {
            top: '-5px',
          },
        },
      },
      content: (
        <div className="tour-guide-popup-container-content">
          <span className="primary-font-semibold tour-guide-popup-container-content-title">
            View Cart
          </span>
          <span className="primary-font-regular tour-guide-popup-container-content-description">
            <span className="primary-font-semibold">
              Click on “Go to cart” to view the items added in the cart
            </span>
          </span>
        </div>
      ),
      placement: 'top-start',
      spotlightClicks: true,
      data: {
        moduleStartTooltip: 2,
        tooltip: true,
        goBack: false,
        arrowDirection: 'bottom-end',
      },
    },
    {
      target:
        '.order-details-screen-v2 .order-details-footer .order-details-footer-btn',
      spotlightPadding: 5,
      disableBeacon: true,
      offset: 0,
      floaterProps: {
        hideArrow: true,
        styles: {
          floaterOpening: {
            top: '-5px',
          },
        },
      },
      content: (
        <div className="tour-guide-popup-container-content">
          <span className="primary-font-semibold tour-guide-popup-container-content-title">
            Checkout
          </span>
          <span className="primary-font-regular tour-guide-popup-container-content-description">
            <span className="primary-font-semibold">
              Click on “Checkout” to order the added products
            </span>
          </span>
        </div>
      ),
      placement: 'top-start',
      spotlightClicks: true,
      data: {
        moduleStartTooltip: 2,
        tooltip: true,
        goBack: false,
        arrowDirection: 'bottom-end',
      },
    },
  ];
};
